import React, { useEffect } from "react";
import { Input, Select, Tooltip } from "antd";
import RegistryFormHeader from "./registryFormHeader";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDev } from "@fortawesome/free-brands-svg-icons";
import { buildIbans } from "../../../libs/fakeGenerator/iban";
import { FEATURE_TOGGLE_ONLY_DEV } from "../../../config";
import { useSelector } from "react-redux";
import LoaderSimple from "../../general/loader";
import { FormattedMessage, useIntl } from "react-intl";

const { Option } = Select;

const RegistryForm = props => {
  const {
    contactBody,
    setContactBody,
    vatNumber,
    setVatNumber,
    taxId,
    setTaxId,
    eoriNumber,
    setEoriNumber,
    country,
    setCountry,
    emailAddress,
    setEmailAddress,
    pecAddress,
    setPecAddress,
    address,
    setAddress,
    onBlurMunicipality,
    municipalityError,
    onBlurProvince,
    provinceError,
    countries,
    onChangeCountry,
    onBlurCap,
    capError,
    ibanError,
    vatError,
    onChangeIban,
    emailError,
    pecError,
    onBlurEmail,
    onBlurPec,
    onBlurTaxId,
    contact,
    isEdit,
    editContactBody,
    setEditContactBody,
    editVatNumber,
    setEditVatNumber,
    editTaxId,
    setEditTaxId,
    editEoriNumber,
    setEditEoriNumber,
    editEmailAddress,
    setEditEmailAddress,
    editPecAddress,
    setEditPecAddress,
    editAddress,
    setEditAddress,
    municipalityEditError,
    provinceEditError,
    capEditError,
    pecEditError,
    ibanEditError,
    emailEditError,
    taxIdError,
    taxIdEditError,
    onEditCountry,
    onBlurEditMunicipality,
    onBlurEditCap,
    onBlurEditProvince,
    onBlurEditPec,
    onBlurEditTaxId,
    onChangeEditIbanValue,
    onBlurEditEmail,
    onBlurVatNumber,
    vatEditError,
    onBlurEditVatNumber,
    contactPecAddress,
    contactVatNumber,
    contactTaxId
  } = props;

  const isEditingState = useSelector(state => state.parties.editParty.status);
  const isLoadingEditing = isEditingState.started && !isEditingState.error;
  const isEndedEditing = isEditingState.ended && !isEditingState.error;

  const isSavingState = useSelector(state => state.parties.createParty.status);
  const isLoadingSaving = isSavingState.started && !isSavingState.error;
  const isEndedSaving = isSavingState.ended && !isSavingState.error;

  const intl = useIntl();

  useEffect(() => {
    if (isEdit) {
      setEditContactBody(editContactBody.length === 0 ? { ...contact } : { ...editContactBody });
      setEditVatNumber(editVatNumber === undefined || editVatNumber.length === 0
        ? contactVatNumber
        : editVatNumber);
      setEditTaxId(editTaxId === undefined || editTaxId.length === 0
        ? contactTaxId
        : editTaxId);
      const eoriObject = contact?.identifiers?.find(i => i.type === "EORI_NUMBER");
      const contactEoriNumber = eoriObject?.value;
      setEditEoriNumber(editEoriNumber === undefined || editEoriNumber.length === 0
        ? contactEoriNumber
        : editEoriNumber);
      const emailAddressObject = contact?.emailAddresses?.find(e => e.type === "STANDARD");
      const contactEmailAddress = emailAddressObject?.value;
      setEditEmailAddress(editEmailAddress === undefined || editEmailAddress.length === 0
        ? contactEmailAddress
        : editEmailAddress);
      setEditPecAddress(editPecAddress === undefined || editPecAddress.length === 0
        ? contactPecAddress
        : editPecAddress);
      setEditAddress(editAddress.municipality === ""
        ? { ...contact?.places?.[0]?.address }
        : { ...editAddress });
    }
  }, [contact]);

  const onChangeCustomerRelationship = () => {
    if (!contactBody?.relationships.includes("CUSTOMER")) {
      setContactBody({
        ...contactBody,
        relationships: [...contactBody.relationships, "CUSTOMER"]
      });
    } else {
      const filteredRelationships = contactBody?.relationships?.filter(r => r !== "CUSTOMER");
      setContactBody({
        ...contactBody,
        relationships: [...filteredRelationships]
      });
    }
  };

  const onChangeSupplierRelationship = () => {
    if (!contactBody?.relationships.includes("SUPPLIER")) {
      setContactBody({
        ...contactBody,
        relationships: [...contactBody.relationships, "SUPPLIER"]
      });
    } else {
      const filteredRelationships = contactBody?.relationships?.filter(r => r !== "SUPPLIER");
      setContactBody({
        ...contactBody,
        relationships: [...filteredRelationships]
      });
    }
  };

  const onChangeStreet = e => {
    setEditAddress({
      ...editAddress,
      street: { ...editAddress.street, name: e.target.value }
    });
  };

  const onChangeNumber = e => {
    setEditAddress({
      ...editAddress,
      street: { ...editAddress.street, number: e.target.value }
    });
  };

  const optionCountries = countries?.map((country, index) => {
    return (
      <Option key={index} value={country}>
        {country}
      </Option>
    );
  });

  const onChangeIbanValue = e => {
    setContactBody({ ...contactBody, iban: e.target.value });
    onChangeIban(e);
  };

  const removeSupplier = () => {
    const newRelationships = [...editContactBody?.relationships];
    const supplier = "SUPPLIER";
    const index = newRelationships.indexOf(supplier);
    if (index > -1) {
      newRelationships.splice(index, 1);
    }
    setEditContactBody({
      ...editContactBody,
      relationships: [...newRelationships]
    });
  };

  const removeCustomer = () => {
    const newRelationships = [...editContactBody?.relationships];
    const customer = "CUSTOMER";
    const index = newRelationships.indexOf(customer);
    if (index > -1) {
      newRelationships.splice(index, 1);
    }
    setEditContactBody({
      ...editContactBody,
      relationships: [...newRelationships]
    });
  };

  return (
    <>
      {(isLoadingEditing || isLoadingSaving) &&
      !isEndedEditing &&
      !isEndedSaving ? (
          <div className="dbx-parties-list-loading">
            <LoaderSimple />
          </div>
        ) : (
          <div className="registry-form">
            <RegistryFormHeader
              contactBody={contactBody}
              setContactBody={setContactBody}
              country={country}
              setCountry={setCountry}
              countries={countries}
              isEdit={isEdit}
              editContactBody={editContactBody}
              setEditContactBody={setEditContactBody}
              editAddress={editAddress}
              onEditCountry={onEditCountry}
              onBlurTaxId={onBlurTaxId}
              taxId={taxId}
              onBlurEditTaxId={onBlurEditTaxId}
              editTaxId={editTaxId}
            />

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                marginBottom: 30
              }}
            >
              <div className="registry-form-column">
                <div className="registry-form-field">
                  <div className="registry-form-field-text">
                    <FormattedMessage id="addressBook.create.vat.label" />
                    {(!isEdit && !vatError && vatError !== null) ||
                  (isEdit && !vatEditError && vatEditError !== null) ? (
                        <FontAwesomeIcon
                          icon={["far", "check"]}
                          className="registry-form-field-check"
                        />
                      ) : null}
                  </div>
                  <Input
                    autoFocus
                    tabIndex={3}
                    className={`registry-form-field-input ${(vatError ||
                    vatEditError) &&
                    "registry-form-error-field"}`}
                    placeholder={"00000000000"}
                    onBlur={e =>
                      !isEdit ? onBlurVatNumber(e) : onBlurEditVatNumber(e)
                    }
                    onChange={e =>
                      !isEdit
                        ? setVatNumber(e.target.value)
                        : setEditVatNumber(e.target.value)
                    }
                    value={!isEdit ? vatNumber : editVatNumber}
                  />
                </div>
                <div className="registry-form-field">
                  <div className="registry-form-field-text">
                    <FormattedMessage id="addressBook.create.name.label" />
                    {contactBody?.type === "PERSON" ||
                  editContactBody?.type === "PERSON"
                      ? " *"
                      : ""}
                  </div>
                  <Input
                    tabIndex={6}
                    className="registry-form-field-input"
                    placeholder={intl.formatMessage({ id: "addressBook.create.name.placeholder" })}
                    onChange={e =>
                      !isEdit
                        ? setContactBody({
                          ...contactBody,
                          firstName: e.target.value
                        })
                        : setEditContactBody({
                          ...editContactBody,
                          firstName: e.target.value
                        })
                    }
                    value={
                      !isEdit ? contactBody.firstName : editContactBody?.firstName
                    }
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <div className="registry-form-field-text"><FormattedMessage id="addressBook.create.addressCountry.label" /> *</div>
                  <Select
                    tabIndex={9}
                    getPopupContainer={trigger => trigger.parentNode}
                    showSearch
                    style={{ width: "100%" }}
                    className="registry-form-field-select"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    placeholder={intl.formatMessage({ id: "addressBook.create.addressCountry.placeholder" })}
                    onChange={e =>
                      !isEdit ? onChangeCountry(e) : onEditCountry(e)
                    }
                    value={
                      !isEdit && address?.country
                        ? address?.country
                        : editAddress?.country
                    }
                  >
                    {optionCountries}
                  </Select>
                </div>
                <div className="registry-form-field">
                  <div className="registry-form-field-text">
                  Email *
                    {(!isEdit && !emailError && emailError !== null) ||
                  (isEdit && !emailEditError && emailEditError !== null) ? (
                        <FontAwesomeIcon
                          icon={["far", "check"]}
                          className="registry-form-field-check"
                        />
                      ) : null}
                  </div>
                  <Input
                    tabIndex={15}
                    className={`registry-form-field-input ${(emailError ||
                    emailEditError) &&
                    "registry-form-error-field"}`}
                    placeholder={intl.formatMessage({ id: "actions.insert" }) + " email"}
                    onBlur={e => (!isEdit ? onBlurEmail(e) : onBlurEditEmail(e))}
                    onChange={e =>
                      !isEdit
                        ? setEmailAddress(e.target.value)
                        : setEditEmailAddress(e.target.value)
                    }
                    value={!isEdit ? emailAddress : editEmailAddress}
                  />
                </div>
                {/* <div className="registry-form-field">
              <div className="registry-form-field-text">
                Telefono fisso
              </div>
              <Input
                className="registry-form-field-input"
                placeholder={"+00 00000000000"}
                onChange={e =>
                  setContactBody({...contactBody, landlinePhone: e.target.value})
                }
                value={contactBody.landlinePhone}
              />
            </div> */}
              </div>

              <div className="registry-form-column">
                <div className="registry-form-field">
                  <div className="registry-form-field-text">
                    <FormattedMessage id="addressBook.create.tax.label" />
                    {(!isEdit && !taxIdError && taxIdError !== null) ||
                  (isEdit && !taxIdEditError && taxIdEditError !== null) ? (
                        <FontAwesomeIcon
                          icon={["far", "check"]}
                          className="registry-form-field-check"
                        />
                      ) : null}
                  </div>
                  <Input
                    tabIndex={4}
                    className={`registry-form-field-input ${(taxIdError ||
                    taxIdEditError) &&
                    "registry-form-error-field"}`}
                    placeholder={intl.formatMessage({ id: "addressBook.create.tax.placeholder" })}
                    onBlur={e => (!isEdit ? onBlurTaxId(e) : onBlurEditTaxId(e))}
                    onChange={e =>
                      !isEdit
                        ? setTaxId(e.target.value)
                        : setEditTaxId(e.target.value)
                    }
                    value={!isEdit ? taxId : editTaxId}
                  />
                </div>
                <div className="registry-form-field">
                  <div className="registry-form-field-text">
                    <FormattedMessage  id="addressBook.create.surname.label" />
                    {contactBody?.type === "PERSON" ||
                  editContactBody?.type === "PERSON"
                      ? " *"
                      : ""}
                  </div>
                  <Input
                    tabIndex={7}
                    className="registry-form-field-input"
                    placeholder={intl.formatMessage({ id: "addressBook.create.surname.placeholder" })}
                    onChange={e =>
                      !isEdit
                        ? setContactBody({
                          ...contactBody,
                          lastName: e.target.value
                        })
                        : setEditContactBody({
                          ...editContactBody,
                          lastName: e.target.value
                        })
                    }
                    value={
                      !isEdit ? contactBody.lastName : editContactBody?.lastName
                    }
                  />
                </div>
                <div
                  className="registry-form-field"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ width: "50%" }}>
                    <div className="registry-form-field-text">
                      <FormattedMessage id="addressBook.create.addressCity.label" /> *
                      {(!isEdit &&
                      !municipalityError &&
                      municipalityError !== null) ||
                    (isEdit &&
                      !municipalityEditError &&
                      municipalityEditError !== null) ? (
                          <FontAwesomeIcon
                            icon={["far", "check"]}
                            className="registry-form-field-check"
                          />
                        ) : null}
                    </div>
                    <Input
                      tabIndex={10}
                      disabled={
                        (!isEdit && address.country) ||
                      (isEdit && editAddress.country)
                          ? false
                          : true
                      }
                      className={`registry-form-field-input ${(municipalityError ||
                      municipalityEditError) &&
                      "registry-form-error-field"}`}
                      placeholder={intl.formatMessage({ id: "addressBook.create.addressCity.placeholder" })}
                      onChange={e =>
                        !isEdit
                          ? setAddress({
                            ...address,
                            municipality: e.target.value
                          })
                          : setEditAddress({
                            ...editAddress,
                            municipality: e.target.value
                          })
                      }
                      onBlur={e =>
                        isEdit ? onBlurEditMunicipality(e) : onBlurMunicipality(e)
                      }
                      value={
                        !isEdit ? address.municipality : editAddress?.municipality
                      }
                    />
                  </div>
                  <div style={{ width: "20%" }}>
                    <div className="registry-form-field-text">
                      <FormattedMessage id="addressBook.create.addressZip.label" /> *
                      {(!isEdit && !capError && capError !== null) ||
                    (isEdit && !capEditError && capEditError !== null) ? (
                          <FontAwesomeIcon
                            icon={["far", "check"]}
                            className="registry-form-field-check"
                          />
                        ) : null}
                    </div>
                    <Input
                      tabIndex={11}
                      disabled={
                        (!isEdit && address.municipality) ||
                      (isEdit && editAddress.municipality)
                          ? false
                          : true
                      }
                      className={`registry-form-field-input ${(capError ||
                      capEditError) &&
                      "registry-form-error-field"}`}
                      placeholder={"00000"}
                      onChange={e =>
                        !isEdit
                          ? setAddress({ ...address, cap: e.target.value })
                          : setEditAddress({
                            ...editAddress,
                            postalCode: e.target.value
                          })
                      }
                      onBlur={e => (!isEdit ? onBlurCap(e) : onBlurEditCap(e))}
                      value={!isEdit ? address.cap : editAddress?.postalCode}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <div className="registry-form-field-text">
                      <FormattedMessage id="addressBook.create.addressProvince.label" /> *
                      {(!isEdit && !provinceError && provinceError !== null) ||
                    (isEdit &&
                      !provinceEditError &&
                      provinceEditError !== null) ? (
                          <FontAwesomeIcon
                            icon={["far", "check"]}
                            className="registry-form-field-check"
                          />
                        ) : null}
                    </div>
                    <Input
                      tabIndex={12}
                      disabled={
                        (!isEdit && address.municipality) ||
                      (isEdit && editAddress.municipality)
                          ? false
                          : true
                      }
                      className={`registry-form-field-input ${(provinceError ||
                      provinceEditError) &&
                      "registry-form-error-field"}`}
                      placeholder={intl.formatMessage({ id: "addressBook.create.addressProvince.placeholder" })}
                      onChange={e =>
                        !isEdit
                          ? setAddress({ ...address, province: e.target.value })
                          : setEditAddress({
                            ...editAddress,
                            province: e.target.value
                          })
                      }
                      onBlur={e =>
                        !isEdit ? onBlurProvince(e) : onBlurEditProvince(e)
                      }
                      value={!isEdit ? address.province : editAddress?.province}
                    />
                  </div>
                </div>
                <div className="registry-form-field">
                  <div className="registry-form-field-text">
                    <FormattedMessage id="addressBook.create.addressPec.label" />
                    {(!isEdit && !pecError && pecError !== null) ||
                  (isEdit && !pecEditError && pecEditError !== null) ? (
                        <FontAwesomeIcon
                          icon={["far", "check"]}
                          className="registry-form-field-check"
                        />
                      ) : null}
                  </div>
                  <Input
                    tabIndex={16}
                    className={`registry-form-field-input ${(pecError ||
                    pecEditError) &&
                    "registry-form-error-field"}`}
                    placeholder={intl.formatMessage({ id: "addressBook.create.addressPec.placeholder" })}
                    onBlur={e => (!isEdit ? onBlurPec(e) : onBlurEditPec(e))}
                    onChange={e =>
                      !isEdit
                        ? setPecAddress(e.target.value)
                        : setEditPecAddress(e.target.value)
                    }
                    value={!isEdit ? pecAddress : editPecAddress}
                  />
                </div>
                {/* <div className="registry-form-field">
              <div className="registry-form-field-text">
                Mobile
              </div>
              <Input
                className="registry-form-field-input"
                placeholder={"+00 00000000000"}
                onChange={e =>
                  setContactBody({...contactBody, mobilePhone: e.target.value})
                }
                value={contactBody.mobilePhone}
              />
            </div> */}
              </div>

              <div className="registry-form-column">
                {/* <div className="registry-form-field">
              <div className="registry-form-field-text">REA</div>
              <Input
                tabIndex={5}
                className="registry-form-field-input"
                placeholder={"Inserisci il Codice REA"}
                onChange={e =>
                  !isEdit ? setContactBody({...contactBody, rea: e.target.value})
                  : setEditContactBody({...editContactBody, rea: e.target.value})
                }
                value={!isEdit ? contactBody?.reaNumber : editContactBody?.reaNumber}
              />
            </div> */}
                <div className="registry-form-field">
                  <div className="registry-form-field-text">{intl.formatMessage({ id: "addressBook.create.eori.label" })}</div>
                  <Input
                    tabIndex={5}
                    className="registry-form-field-input"
                    placeholder={intl.formatMessage({ id: "addressBook.create.eori.placeholder" })}
                    onChange={e =>
                      !isEdit
                        ? setEoriNumber(e.target.value)
                        : setEditEoriNumber(e.target.value)
                    }
                    value={!isEdit ? eoriNumber : editEoriNumber}
                  />
                </div>
                <div className="registry-form-field">
                  <div className="registry-form-field-text">
                    {intl.formatMessage({ id: "addressBook.create.sdi.label" })}
                  </div>
                  <Input
                    tabIndex={8}
                    className="registry-form-field-input"
                    placeholder={intl.formatMessage({ id: "addressBook.create.sdi.placeholder" })}
                    onChange={e =>
                      !isEdit
                        ? setContactBody({
                          ...contactBody,
                          sdiId: e.target.value
                        })
                        : setEditContactBody({
                          ...editContactBody,
                          sdiId: e.target.value
                        })
                    }
                    value={!isEdit ? contactBody.sdiId : editContactBody?.sdiId}
                  />
                </div>
                <div
                  className="registry-form-field"
                  style={{ display: "flex", gap: 20 }}
                >
                  <div className="registry-form-field">
                    <div className="registry-form-field-text">{intl.formatMessage({ id: "addressBook.create.addressSpaceType.placeholder" })} *</div>
                    <Input
                      tabIndex={13}
                      className="registry-form-field-input"
                      placeholder={intl.formatMessage({ id: "addressBook.create.addressSpaceType.placeholder" })}
                      onChange={e =>
                        !isEdit
                          ? setAddress({ ...address, street: e.target.value })
                          : onChangeStreet(e)
                      }
                      value={!isEdit ? address.street : editAddress?.street?.name}
                    />
                  </div>
                  <div style={{ width: "16%" }}>
                    <div className="registry-form-field-text">Num. *</div>
                    <Input
                      tabIndex={14}
                      className="registry-form-field-input"
                      placeholder={"n."}
                      onChange={e =>
                        !isEdit
                          ? setAddress({ ...address, number: e.target.value })
                          : onChangeNumber(e)
                      }
                      value={
                        !isEdit ? address.number : editAddress?.street?.number
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: 20,
                flexDirection: "row",
                marginBottom: 35
              }}
            >
              <div className="registry-form-field">
                <div className="registry-form-field-text">
                IBAN
                  {(!isEdit && !ibanError && ibanError !== null) ||
                (isEdit && !ibanEditError && ibanEditError !== null) ? (
                      <FontAwesomeIcon
                        icon={["far", "check"]}
                        className="registry-form-field-check"
                      />
                    ) : null}
                </div>
                <Input
                  tabIndex={17}
                  className={`registry-form-field-input ${(ibanError ||
                  ibanEditError) &&
                  "registry-form-error-field"}`}
                  placeholder={intl.formatMessage({id: "actions.insert"}) + " IBAN"}
                  onChange={e =>
                    !isEdit ? onChangeIbanValue(e) : onChangeEditIbanValue(e)
                  }
                  value={
                    !isEdit
                      ? contactBody.iban
                      : editContactBody?.bankAccounts?.[0]?.iban
                  }
                  suffix={
                    FEATURE_TOGGLE_ONLY_DEV === "true" ? (
                      <Tooltip color={"rgb(0, 80, 117)"}
                        title="[DEV] generate iban">
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setContactBody({
                              ...contactBody,
                              iban: buildIbans("Italy")
                            })
                          }
                        >
                          <FontAwesomeIcon icon={faDev} />
                        </div>
                      </Tooltip>
                    ) : null
                  }
                />
              </div>
              <div
                className="registry-form-field"
                style={{ display: "flex", gap: 20, marginTop: 30, width: "49%" }}
              >
                <div
                  style={{ display: "flex", gap: 10, alignItems: "center" }}
                  onClick={() =>
                    !isEdit
                      ? onChangeCustomerRelationship()
                      : isEdit &&
                      editContactBody?.relationships?.includes("CUSTOMER")
                        ? removeCustomer()
                        : isEdit &&
                      !editContactBody?.relationships?.includes("CUSTOMER")
                          ? setEditContactBody({
                            ...editContactBody,
                            relationships: [
                              ...editContactBody.relationships,
                              "CUSTOMER"
                            ]
                          })
                          : null
                  }
                >
                  <div
                    style={{ marginTop: 0, cursor: "pointer" }}
                    className={
                      "registry-form-type-icon" +
                    ((!isEdit &&
                      contactBody?.relationships?.includes("CUSTOMER")) ||
                    (isEdit &&
                      editContactBody?.relationships?.includes("CUSTOMER"))
                      ? " active"
                      : "")
                    }
                  >
                    <FontAwesomeIcon icon={["far", "male"]} />
                  </div>
                  <div className="registry-form-icon-text">{intl.formatMessage({ id: "addressBook.customer" })?.toUpperCase()}</div>
                </div>
                <div
                  style={{ display: "flex", gap: 10, alignItems: "center" }}
                  onClick={() =>
                    !isEdit
                      ? onChangeSupplierRelationship()
                      : isEdit &&
                      editContactBody?.relationships?.includes("SUPPLIER")
                        ? removeSupplier()
                        : isEdit &&
                      !editContactBody?.relationships?.includes("SUPPLIER")
                          ? setEditContactBody({
                            ...editContactBody,
                            relationships: [
                              ...editContactBody?.relationships,
                              "SUPPLIER"
                            ]
                          })
                          : null
                  }
                >
                  <div
                    style={{ marginTop: 0, fontSize: 18, cursor: "pointer" }}
                    className={
                      "registry-form-type-icon" +
                    ((!isEdit &&
                      contactBody?.relationships?.includes("SUPPLIER")) ||
                    (isEdit &&
                      editContactBody?.relationships?.includes("SUPPLIER"))
                      ? " active"
                      : "")
                    }
                  >
                    <FontAwesomeIcon icon={["far", "truck"]} />
                  </div>
                  <div className="registry-form-icon-text">{intl.formatMessage({ id: "addressBook.supplier" })?.toUpperCase()}</div>
                </div>
              </div>
            </div>
          </div>
        )}{" "}
    </>
  );
};

export default RegistryForm;
